import { DeviceProject } from 'types/cot.types';

const INVENTORY = 'inventory';

export const isInventoryProject = (project?: DeviceProject) => {
  return project?.name.toLowerCase() === INVENTORY;
};
